/**
 * <brick-localization>
 * Submits the country/language form as soon as a select changes and hides
 * the fallback submit button (kept for no-JS users).
 */
(() => {
  if (customElements.get('brick-localization')) return;

  class BrickLocalization extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      if (!form) return;
      const submit = this.querySelector('[data-localization-submit]');
      if (submit) submit.hidden = true;
      form.addEventListener('change', (event) => {
        if (event.target.matches('select')) form.submit();
      });
    }
  }

  customElements.define('brick-localization', BrickLocalization);
})();
